export const name = 'support';

export const Support = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="#161619"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.82388 19.0881L4 21.5L4.65323 16.9274C3.00629 15.5013 2 13.5947 2 11.5C2 7.08172 6.47715 3.5 12 3.5C17.5228 3.5 22 7.08172 22 11.5C22 15.9183 17.5228 19.5 12 19.5C10.8897 19.5 9.82175 19.3553 8.82388 19.0881Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
